module.exports = __webpack_public_path__ + "media/metronic/_theme/media/blog/blog5-2cd33f9aa11218a4ac7dc8143fbc6d00.jpg";